import React, { useContext } from 'react';
import { SliderContext } from "../providers/SliderProvider.js";
import styles from "./SliderNotch.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function SliderNotch({
  value
}) {
  const {
    calcCSSPosition
  } = useContext(SliderContext);
  return /*#__PURE__*/_jsx("div", {
    className: styles.notch,
    style: {
      '--slider-notch-left': calcCSSPosition(value)
    }
  });
}